import React from 'react'

function IconSearch() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_109_2)">
        <path
          d="M20 0.00500488C13.373 0.00500488 8 5.37801 8 12.005C8 14.031 8.507 15.938 9.395 17.613L1.051 25.955L1.058 25.961C0.406 26.602 0 27.49 0 28.477C0 30.426 1.58 32.006 3.529 32.006C4.514 32.006 5.403 31.6 6.044 30.947L6.042 30.945L14.383 22.605C16.059 23.496 17.969 24.005 20 24.005C26.627 24.005 32 18.632 32 12.005C32 5.37801 26.627 0.00500488 20 0.00500488ZM4.795 29.697C4.473 30.031 4.027 30.24 3.529 30.24C2.554 30.24 1.764 29.451 1.764 28.476C1.764 27.978 1.974 27.533 2.307 27.21L2.298 27.202L10.364 19.136C11.069 20.087 11.909 20.927 12.858 21.634L4.795 29.697ZM20 22.006C14.478 22.006 10 17.527 10 12.006C10 6.484 14.478 2.006 20 2.006C25.521 2.006 30 6.484 30 12.006C30 17.527 25.521 22.006 20 22.006Z"
          fill="#333333"
        />
        <path
          d="M20 5.005C16.133 5.005 13 8.139 13 12.005C13 12.281 13.224 12.505 13.5 12.505C13.776 12.505 14 12.281 14 12.005C14 8.692 16.686 6.005 20 6.005C20.275 6.005 20.5 5.781 20.5 5.505C20.5 5.229 20.275 5.005 20 5.005Z"
          fill="#333333"
        />
      </g>
      <defs>
        <clipPath id="clip0_109_2">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconSearch
